module.exports = __webpack_public_path__ + "img/g1-1-m.bc7351bb.png";